import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import AuthAPI from "../../Api/authApi";
import EventBus from "../../utils/EventBus";

const user = JSON.parse(localStorage.getItem("user"));

export const register = createAsyncThunk(
  "auth/register",
  async ({ username, email, password }, thunkAPI) => {
    try {
      const response = await AuthAPI.register(username, email, password);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    return thunkAPI.rejectWithValue(message)
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const data = await AuthAPI.login(email, password);
      return { user: data };

    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      thunkAPI.dispatch(setMessage(message))
      return thunkAPI.rejectWithValue(message)
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await AuthAPI.logout();
});



export const fetchUserProfile = createAsyncThunk(
  "auth/fetchUserProfile",
  async ( thunkAPI) => {
    try {
      const response = await AuthAPI.getUserProfile();
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = user
  ? { isLoggedIn: true, user,profile: null }
  : { isLoggedIn: false, user: null, profile: null  };

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(register.fulfilled, (state) => {
        state.isLoggedIn = false;
      })
      .addCase(register.rejected, (state) => {
        state.isLoggedIn = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.user = action.payload.user;
      })
      .addCase(login.rejected, (state) => {
        state.isLoggedIn = false;
        state.user = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isLoggedIn = false;
        state.user = null;
      })

      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        // console.log("profile",action.payload)
        state.profile = action.payload; 
      })
      .addCase(fetchUserProfile.rejected, (state) => {
        state.profile = null; 
      });
  },
});

const { reducer } = authSlice;
export default reducer;
